import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInwaitContract = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.31553 3.79957C6.31696 3.99156 7.35569 3.5613 7.92806 2.71743C8.43444 1.97084 9.56556 1.97084 10.0719 2.71743C10.6443 3.5613 11.683 3.99156 12.6845 3.79957C13.5705 3.62972 14.3703 4.42954 14.2004 5.31553C14.0084 6.31696 14.4387 7.35569 15.2826 7.92806C16.0292 8.43444 16.0292 9.56556 15.2826 10.0719C14.4387 10.6443 14.0084 11.683 14.2004 12.6845C14.3703 13.5705 13.5705 14.3703 12.6845 14.2004C11.683 14.0084 10.6443 14.4387 10.0719 15.2826C9.56556 16.0292 8.43444 16.0292 7.92806 15.2826C7.35569 14.4387 6.31696 14.0084 5.31553 14.2004C4.42954 14.3703 3.62972 13.5705 3.79957 12.6845C3.99156 11.683 3.5613 10.6443 2.71743 10.0719C1.97084 9.56556 1.97084 8.43444 2.71743 7.92806C3.5613 7.35569 3.99156 6.31696 3.79957 5.31553C3.62972 4.42954 4.42954 3.62972 5.31553 3.79957Z",
		stroke: "#555D5F",
		strokeWidth: 1.27644
	})
});
export default SvgInwaitContract;
